import {
  Component,
  EventEmitter,
  Input,
  Output,
  HostListener,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'app-overlay-drawer',
  template: `
    <div class="relative w-full h-full overflow-hidden">
      <!-- MAIN CONTENT SLOT -->
      <ng-content select="[main]"></ng-content>

      <!-- BACKDROP -->
      <div
        *ngIf="opened"
        class="fixed inset-0 bg-black bg-opacity-50 z-[300] transition-opacity duration-300"
        (click)="drawerToggled.emit()"
      ></div>

      <!-- DRAWER: apply width to the fuse-drawer element -->
      <fuse-drawer
        [name]="name"
        [opened]="opened"
        [mode]="mode"
        position="right"
        class="fixed top-0 right-0 h-full z-[300] shadow-2xl bg-white transition-transform duration-300"
        (openedChange)="drawerOpenedChange.emit($event)"
      >
        <div class="p-3 w-full h-full flex flex-col">
          <!-- HEADER -->
          <div class="flex justify-between items-center mb-6 border-b pb-3">
            <h2 class="text-xl font-semibold text-gray-800">{{ title }}</h2>
            <button mat-icon-button (click)="drawerToggled.emit()">
              <mat-icon>close</mat-icon>
            </button>
          </div>

          <!-- DRAWER CONTENT -->
          <div class="flex-1 overflow-auto w-full">
            <ng-content select="[drawer]"></ng-content>
          </div>
        </div>
      </fuse-drawer>
    </div>
  `,
})
export class OverlayDrawerComponent {
  @Input() name!: string;
  @Input() opened = false;
  @Input() mode: 'over' | 'side' = 'over';
  @Input() title = '';

  /** Default width — can be overridden by input, or adjusts responsively */
  @Input() width: string | number = '600px';

  @Output() drawerToggled = new EventEmitter<void>();
  @Output() drawerOpenedChange = new EventEmitter<boolean>();

  get computedWidth(): string {
    if (typeof this.width === 'number') {
      return `${this.width}px`;
    }
    return this.width || '300px';
  }
}
